import { NavLink, Navigate, Route, Routes } from 'react-router-dom';

import { Gate, useAuth } from '../../../global/contexts/auth/auth';
import AttentionScreen from './attention';
import HistoryScreen from './history';
import MetricsScreen from './metrics';
import FleetScreen from './fleet';
import { DemoBanner } from './bits';

import '../styles/coordination.css';
import '../styles/fleet.css';

const BASE = '/admin/agents';
const TABS = [
    ['puestos', 'Equipos', 'machines:read'],
    ['atencion', 'Necesita atención', 'events:read'],
    ['historial', 'Actividad', 'events:read'],
    ['tiempos', 'Tiempos', 'events:read'],
];

export default function CoordinationPanel() {
    const { can } = useAuth();
    const landing = can('machines:read') ? 'puestos' : 'atencion';
    const denied = <p className="coord__empty">Tu cuenta no tiene acceso a esta vista.</p>;
    return (
        <div className="coord-shell">
            <header className="coord-shell__head">
                <div>
                    <span className="coord-shell__eyebrow">Trabajo</span>
                    <h1 className="coord-shell__title">Agentes</h1>
                    <p className="coord-shell__lead">Supervisa y controla tus agentes.</p>
                </div>
            </header>
            <DemoBanner />
            <nav className="coord-shell__tabs" aria-label="Vistas de agentes">
                {TABS.map(([slug, text, permission]) => (
                    <Gate key={slug} domain={permission}>
                        <NavLink
                            to={`${BASE}/${slug}`}
                            className={({ isActive }) =>
                                `coord-shell__tab${isActive ? ' coord-shell__tab--on' : ''}`
                            }
                        >
                            {text}
                        </NavLink>
                    </Gate>
                ))}
            </nav>
            <div className="coord-shell__main">
                <Routes>
                    <Route index element={<Navigate to={`${BASE}/${landing}`} replace />} />
                    <Route
                        path="puestos"
                        element={
                            <Gate domain="machines:read" fallback={denied}>
                                <FleetScreen />
                            </Gate>
                        }
                    />
                    <Route
                        path="atencion"
                        element={
                            <Gate domain="events:read" fallback={denied}>
                                <AttentionScreen />
                            </Gate>
                        }
                    />
                    <Route
                        path="historial"
                        element={
                            <Gate domain="events:read" fallback={denied}>
                                <HistoryScreen />
                            </Gate>
                        }
                    />
                    <Route
                        path="tiempos"
                        element={
                            <Gate domain="events:read" fallback={denied}>
                                <MetricsScreen />
                            </Gate>
                        }
                    />
                    <Route
                        path="controles"
                        element={<Navigate to={`${BASE}/${landing}`} replace />}
                    />
                    <Route path="*" element={<Navigate to={`${BASE}/${landing}`} replace />} />
                </Routes>
            </div>
        </div>
    );
}
